<div *ngIf="!project">Loading...</div>
<form *ngIf="project" class="all" #form="ngForm" (click)="formTouched()">
    <div class="page-col">
        <app-info-group headline="General" size="small">
            <app-info-group-body>
                <table>
                    <tr class="required">
                        <td class="col-label">Project name</td>
                        <td class="col-value">
                            <input
                                class="form-control {{isFilled(project.name)}}"
                                type="text"
                                [(ngModel)]="project.name"
                                id="name"
                                title="Project name"
                                placeholder="Project name"
                                name="name"
                            />
                        </td>
                    </tr>

                    <tr
                        *ngFor="let cust of selectedCustomers; first as isFirst"
                    >
                        <td class="col-label">
                            <div *ngIf="isFirst">Customers</div>
                        </td>
                        <td class="col-value readonly">
                            <div style="display: flex; align-items: center">
                                {{ cust.name }}
                                <div style="flex-grow: 1"></div>
                                <button
                                    type="button"
                                    style="align-self: flex-start"
                                    class="btn btn-sm btn-outline-danger"
                                    (click)="removeCustomer(cust)"
                                >
                                    <fa-icon [icon]="faDelete"></fa-icon>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr [class]="{ required: !isLoaded(selectedCustomers) }">
                        <td class="col-label">
                            <span *ngIf="!isLoaded(selectedCustomers)"
                                >Customers</span
                            >
                        </td>
                        <td class="col-value">
                            <input
                                id="customer"
                                class="form-control {{isFilled(project.customerIds)}}"
                                [(ngModel)]="selectedCustomer"
                                [ngbTypeahead]="searchCustomer"
                                [inputFormatter]="customerFormatter"
                                [resultFormatter]="customerFormatter"
                                [editable]="false"
                                container="body"
                                #customerSearch
                                (selectItem)="
                                    onCustomerSelect($event, customerSearch)
                                "
                                placeholder="Search..."
                                name="customer"
                            />
                        </td>
                    </tr>

                    <tr class="required">
                        <td class="col-label">Project No.</td>
                        <td class="col-value">
                            <input
                                class="form-control {{isFilled(project.caseNumber)}}"
                                type="text"
                                [(ngModel)]="project.caseNumber"
                                id="caseNumber"
                                name="caseNumber"
                                placeholder="Case Number"
                                title="Case Number"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">Status</td>
                        <td class="col-value">
                            <select
                                [(ngModel)]="project.projectStatus"
                                class="form-control"
                                name="status"
                            >
                                <option [ngValue]="ProjectStatus.Initial">
                                    Not Started
                                </option>
                                <option [ngValue]="ProjectStatus.Started">
                                    In Progress
                                </option>
                                <option [ngValue]="ProjectStatus.Completed">
                                    Completed
                                </option>
                            </select>
                        </td>
                    </tr>
                </table>
            </app-info-group-body>
        </app-info-group>

        <app-edit-postal-address-inner
            [postalAddress]="project.shipper"
            displayName="Shipper"
        ></app-edit-postal-address-inner>

        <app-edit-postal-address-inner
            [postalAddress]="project.consignee"
            displayName="Consignee"
        ></app-edit-postal-address-inner>

        <app-edit-postal-address-inner
            [postalAddress]="project.notifyAddress"
            displayName="Notify Address"
        ></app-edit-postal-address-inner>

        <app-info-group headline="Internal Note" size="small">
            <app-info-group-body>
                <textarea
                    class="form-control"
                    name="internalNote"
                    style="height: 160px"
                    placeholder="Write internal information here"
                    [(ngModel)]="project.internalNote"
                >
                </textarea>
            </app-info-group-body>
        </app-info-group>
    </div>

    <div class="page-col">
        <app-info-group headline="Vessel" size="large">
            <app-info-group-body>
                <table>
                    <tr class="required">
                        <td class="col-label">Vessel name</td>
                        <td class="col-value">
                            <input
                                class="form-control {{isFilled(project.shipName)}}"
                                type="text"
                                [(ngModel)]="project.shipName"
                                id="shipname"
                                name="shipname"
                                placeholder="Ship name"
                                title="shipName"
                            />
                        </td>
                    </tr>
                    <tr class="required">
                        <td class="col-label">Voyage number</td>
                        <td class="col-value">
                            <input
                                class="form-control {{isFilled(project.voyageNumber)}}"
                                type="text"
                                [(ngModel)]="project.voyageNumber"
                                id="voyageNumber"
                                name="voyageNumber"
                                placeholder="Voyage number"
                                title="Voyage Number"
                            />
                        </td>
                    </tr>

                    <tr>
                        <td class="col-label">IMO Number</td>
                        <td class="col-value">
                            <input
                                class="form-control"
                                type="text"
                                [(ngModel)]="project.imoNumber"
                                id="imoNumber"
                                name="imoNumber"
                                placeholder="IMO Number"
                                title="IMO Number"
                            />
                        </td>
                    </tr>
                    <tr class="required">
                        <td class="col-label">Vessel GT</td>
                        <td class="col-value">
                            <input
                                class="form-control  {{isFilled(project.shipWeight)}}"
                                type="number"
                                [(ngModel)]="project.shipWeight"
                                id="shipWeight"
                                name="shipWeight"
                                placeholder="Vessel GT"
                                title="Vessel GT"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">Flag</td>
                        <td class="col-value">
                            <input
                                class="form-control"
                                type="text"
                                [(ngModel)]="project.flag"
                                id="flag"
                                name="flag"
                                placeholder="Flag"
                                title="Flag"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">Owners</td>
                        <td class="col-value">
                            <input
                                class="form-control"
                                type="text"
                                [(ngModel)]="project.owners"
                                id="owners"
                                name="owners"
                                placeholder="Owners"
                                title="Owners"
                            />
                        </td>
                    </tr>

                    <tr>
                        <td class="col-label">Port</td>
                        <td class="col-value">
                            <input
                                class="form-control"
                                type="text"
                                [(ngModel)]="project.port"
                                id="port"
                                name="port"
                                placeholder="Port"
                                title="Port"
                            />
                        </td>
                    </tr>

                    <tr>
                        <td class="col-label">Reference</td>
                        <td class="col-value">
                            <input
                                class="form-control"
                                type="text"
                                [(ngModel)]="project.reference"
                                id="reference"
                                name="reference"
                                placeholder="Reference"
                                title="Reference"
                            />
                        </td>
                    </tr>

                    <tr class="required">
                        <td class="col-label">Coming from</td>
                        <td class="col-value">
                            <input
                                class="form-control {{isFilled(project.from)}}"
                                type="text"
                                [(ngModel)]="project.from"
                                id="from"
                                name="from"
                                placeholder="From"
                                title="From"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">Loading in</td>
                        <td class="col-value">
                            <input
                                class="form-control"
                                type="text"
                                [(ngModel)]="project.loadingIn"
                                id="loadingIn"
                                title="Loading in"
                                placeholder="Loading in"
                                name="loadingIn"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">Discharging in</td>
                        <td class="col-value">
                            <input
                                class="form-control"
                                type="text"
                                [(ngModel)]="project.dischargeIn"
                                id="dischargeIn"
                                title="Discharging in"
                                placeholder="Discharging in"
                                name="dischargeIn"
                            />
                        </td>
                    </tr>
                    <tr class="required">
                        <td class="col-label">Going to</td>
                        <td class="col-value">
                            <input
                                class="form-control {{isFilled(project.to)}}"
                                type="text"
                                [(ngModel)]="project.to"
                                id="to"
                                name="to"
                                placeholder="To"
                                title="To"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">Tug(s) booked</td>
                        <td class="col-value">
                            <select
                                [(ngModel)]="project.isTugBooked"
                                class="form-control"
                                name="isTugBooked"
                            >
                                <option [ngValue]="false">No</option>
                                <option [ngValue]="true">Yes</option>
                            </select>
                        </td>
                    </tr>
                    <tr [hidden]="!project.isTugBooked">
                        <td class="col-label">
                            Tug(s) booked<fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value">
                            <app-tba-date-time
                                [(date)]="project.tugBooked"
                            ></app-tba-date-time>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">Pilot(s) booked</td>
                        <td class="col-value">
                            <select
                                [(ngModel)]="project.isPilotBooked"
                                class="form-control"
                                name="isPilotBooked"
                            >
                                <option [ngValue]="false">No</option>
                                <option [ngValue]="true">Yes</option>
                            </select>
                        </td>
                    </tr>
                    <tr [hidden]="!project.isPilotBooked">
                        <td class="col-label">
                            Pilot booked<fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value">
                            <app-tba-date-time
                                [(date)]="project.pilotBooked"
                            ></app-tba-date-time>
                        </td>
                    </tr>
                    <tr class="required">
                        <td class="col-label">
                            Expected arrival<fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value">
                            <app-tba-date-time class=""
                                [(date)]="project.expectedArrival"
                                id="expectedArrival"
                            ></app-tba-date-time>
                        </td>
                    </tr>
                    <tr class="required">
                        <td class="col-label">
                            Expected departure<fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value">
                            <app-tba-date-time
                                [(date)]="project.expectedDeparture"
                                id="expectedDeparture"
                            ></app-tba-date-time>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">
                            Actual departure<fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value">
                            <app-date-time
                                [(date)]="project.actualDeparture"
                                id="actualDeparture"
                            ></app-date-time>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">Expected arrival next port</td>
                        <td class="col-value">
                            <app-tba-date-time
                                [(date)]="project.expectedArrivalNextPort"
                                id="expectedArrivalNextPort"
                            ></app-tba-date-time>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">Loading/discharge berth</td>
                        <td class="col-value">
                            <input
                                class="form-control"
                                type="text"
                                [(ngModel)]="project.berth"
                                id="berth"
                                title="Berth"
                                placeholder="Berth"
                                name="berth"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">Eosp/pilot station</td>
                        <td class="col-value">
                            <app-date-time
                                [(date)]="project.esop"
                                id="esop"
                            ></app-date-time>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">First line</td>
                        <td class="col-value">
                            <app-date-time
                                [(date)]="project.firstLine"
                                id="firstLine"
                            ></app-date-time>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">
                            All fast<fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value">
                            <app-date-time
                                [(date)]="project.allFast"
                                id="allFast"
                            ></app-date-time>
                        </td>
                    </tr>

                    <tr>
                        <td class="col-label">Nor tendered</td>
                        <td class="col-value">
                            <table>
                                <tr class="checkbox-row">
                                    <td>
                                        <label>
                                            <input
                                                [(ngModel)]="
                                                    project.tenderedType
                                                "
                                                type="radio"
                                                name="NorTendered"
                                                [value]="tenderedTypes[0].value"
                                            />
                                            <span>Unknown</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr class="checkbox-row">
                                    <td>
                                        <label>
                                            <input
                                                [(ngModel)]="
                                                    project.tenderedType
                                                "
                                                type="radio"
                                                name="NorTendered"
                                                [value]="tenderedTypes[1].value"
                                            />
                                            <span>None</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr class="checkbox-row">
                                    <td>
                                        <input
                                            [(ngModel)]="project.tenderedType"
                                            type="radio"
                                            name="NorTendered"
                                            [value]="tenderedTypes[2].value"
                                        />
                                        <app-date-time
                                            *ngIf="
                                                project.tenderedType ===
                                                TenderedType.Date
                                            "
                                            [(date)]="project.norTendered"
                                            id="norTendered"
                                        >
                                        </app-date-time>
                                        <app-date-time
                                            *ngIf="
                                                project.tenderedType !==
                                                TenderedType.Date
                                            "
                                        ></app-date-time>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <tr>
                        <td class="col-label">Nor Received</td>
                        <td class="col-value">
                            <table>
                                <tr class="checkbox-row">
                                    <td>
                                        <label>
                                            <input
                                                [(ngModel)]="
                                                    project.receivedType
                                                "
                                                type="radio"
                                                name="NorReceived"
                                                [value]="receivedTypes[0].value"
                                            />
                                            <span>Unknown</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr class="checkbox-row">
                                    <td>
                                        <label>
                                            <input
                                                [(ngModel)]="
                                                    project.receivedType
                                                "
                                                type="radio"
                                                name="NorReceived"
                                                [value]="receivedTypes[1].value"
                                            />
                                            <span>None</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr class="checkbox-row">
                                    <td>
                                        <input
                                            [(ngModel)]="project.receivedType"
                                            type="radio"
                                            name="NorReceived"
                                            [value]="receivedTypes[2].value"
                                        />
                                        <app-date-time
                                            *ngIf="
                                                project.receivedType ===
                                                ReceivedType.Date
                                            "
                                            [(date)]="project.norReceived"
                                            id="norReceived"
                                        >
                                        </app-date-time>
                                        <app-date-time
                                            *ngIf="
                                                project.receivedType !==
                                                ReceivedType.Date
                                            "
                                        ></app-date-time>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <tr>
                        <td class="col-label">
                            Operation expected to commence<fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value">
                            <app-tba-date-time
                                [(date)]="project.opsCommenced"
                                id="opsCommenced"
                            ></app-tba-date-time>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">
                            Operation commenced<fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value">
                            <app-date-time
                                [(date)]="project.operationsActuallyCommenced"
                                id="opsActuallyCommenced"
                            ></app-date-time>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">
                            Operation expected to complete
                        </td>
                        <td class="col-value">
                            <app-tba-date-time
                                [(date)]="project.opsCompleted"
                                id="opsCompleted"
                            ></app-tba-date-time>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">
                            Operation completed<fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value">
                            <app-date-time
                                [(date)]="project.operationsActuallyCompleted"
                                id="opsActuallyCompleted"
                            ></app-date-time>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-label">
                            Important Information<fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value">
                            <textarea
                                style="height: 160px"
                                class="form-control"
                                name="importantInformation"
                                [(ngModel)]="project.importantInformation"
                            ></textarea>
                        </td>
                    </tr>
                </table>
            </app-info-group-body>
        </app-info-group>
    </div>

    <div class="page-col">
        <app-info-group headline="Cargo">
            <app-info-group-body>
                <table>
                    <tr class="required">
                        <td class="col-label">Cargo description</td>
                        <td class="col-value">
                            <input
                                class="form-control {{isFilled(project.cargoDescription)}}"
                                type="text"
                                [(ngModel)]="project.cargoDescription"
                                id="cargoDescription"
                                title="Cargo description"
                                placeholder="Cargo description"
                                name="cargoDescription"
                            />
                        </td>
                    </tr>
                </table>
            </app-info-group-body>
        </app-info-group>

        <app-info-group headline="Project roles">
            <app-info-group-body>
                <table>
                    <tr class="required">
                        <td class="col-label">Customer rep</td>
                        <td class="col-value">
                            <input
                                class="form-control {{isFilled(project.customerRep)}}"
                                type="text"
                                [(ngModel)]="project.customerRep"
                                id="customerRep"
                                title="Customer rep"
                                placeholder="Customer rep"
                                name="customerRep"
                            />
                        </td>
                    </tr>

                    <tr class="required">
                        <td class="col-label">Stevedore foreman</td>
                        <td class="col-value">
                            <app-project-member-selector
                                [(memberId)]="project.stevedoreForemanId"
                                [memberRole]="stevedoreForemanRole"
                            ></app-project-member-selector>
                        </td>
                    </tr>

                    <tr class="required">
                        <td class="col-label">Agent (Opc)</td>
                        <td class="col-value">
                            <app-project-member-selector
                                [(memberId)]="project.opcAgentId"
                                [memberRole]="opcAgentRole"
                            ></app-project-member-selector>
                        </td>
                    </tr>

                    <tr>
                        <td class="col-label">Surveyor</td>
                        <td class="col-value">
                            <input
                                class="form-control"
                                type="text"
                                [(ngModel)]="project.surveyor"
                                id="surveyor"
                                title="Surveyor"
                                placeholder="Surveyor"
                                name="surveyor"
                            />
                        </td>
                    </tr>

                    <tr>
                        <td class="col-label">Lifting supervisor</td>
                        <td class="col-value">
                            <input
                                class="form-control"
                                type="text"
                                [(ngModel)]="project.liftingSupervisor"
                                id="liftingSupervisor"
                                title="Lifting supervisor"
                                placeholder="Lifting supervisor"
                                name="liftingSupervisor"
                            />
                        </td>
                    </tr>
                </table>
            </app-info-group-body>
        </app-info-group>

        <app-info-group headline="Cranes">
            <app-info-group-body>
                <table>
                    <tr class="checkbox-row required " *ngFor="let ct of craneTypes">
                        <td class="col-label">
                            <label for="ct{{ ct.value }}">{{ ct.name }}</label
                            ><fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value {{isFilled(project.craneType==='Unknown'?'':'filled')}}">
                            <input

                                type="radio"
                                [(ngModel)]="project.craneType"
                                [value]="ct.value"
                                name="craneType"
                                id="ct{{ ct.value }}"
                            />
                        </td>
                    </tr>

                    <tr class="required">
                        <td class="col-label">
                            Crane(s) booked
                            <fa-icon
                                class="mailIcon"
                                [icon]="faEnvelope"
                            ></fa-icon>
                        </td>
                        <td class="col-value">
                            <select
                                [(ngModel)]="project.shoreCraneBooked"
                                class="form-control {{isFilled(project.shoreCraneBooked)}}"
                                name="shoreCraneBooked"
                            >
                                <option [ngValue]="false">No</option>
                                <option [ngValue]="true">Yes</option>
                            </select>
                        </td>
                    </tr>
                </table>
            </app-info-group-body>
        </app-info-group>

        <app-info-group headline="Power">
            <app-info-group-body>
                <table>
                    <tr class="required">
                        <td>Power provider</td>
                        <td>
                            <div class="power-radio-group {{isFilled(project.usingShorePower)}}">
                                <label for="vesselPower">
                                    <input
                                        [(ngModel)]="project.usingShorePower"
                                        type="radio"
                                        [value]="false"
                                        name="powerProvider"
                                        id="vesselPower"
                                    />
                                    Vessel power
                                </label>
                                <label for="shorePower">
                                    <input
                                        [(ngModel)]="project.usingShorePower"
                                        type="radio"
                                        [value]="true"
                                        name="powerProvider"
                                        id="shorePower"
                                    />
                                    Shore power
                                </label>
                            </div>
                        </td>
                    </tr>
                </table>
            </app-info-group-body>
        </app-info-group>
    </div>
</form>
